import { Vue, Component } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

// External components
import DashboardTabContent from "@/components/dashboardTabContent/dashboardTabContent";
import ReactivateSubscription from "@/components/editSubscription/reactivateSubscription/reactivateSubscription";
import ModalConfirmOrder from "@/components/modalConfirmOrder/modalConfirmOrder";
import ModalAddDocument from "@/components/modalAddDocument/modalAddDocument";

// Helpers
import { isOrderInTerminalStatus } from "@/plugins/subscriptions_helper";
import { isMissingDocumentInformation } from "@/plugins/user_helper";

@Component({
  components: {
    DashboardTabContent,
    ReactivateSubscription,
    ModalConfirmOrder,
    ModalAddDocument,
  },
})
export default class SubscriptionOrderDetail extends Vue {
  @Action action_updateSubscription;
  @Action action_confirmSubscriptionOrder;

  @Getter getSubscription;
  @Getter getCity;
  @Getter getCurrentOrder;
  @Getter getDashboardSelectedTabIndex;
  @Getter getIsUnderMobile;
  @Getter getUser;

  @Mutation SPINNER;
  @Mutation DASHBOARD_SELECTED_TAB_INDEX;

  isShowingSidebar = false;
  isShowingConfirmOrderModal = false;
  isShowingAddDocumentModal = false;

  // Modal Test
  openModal = false;
  openEditModal = false;
  openFilterDropdown = false;
  openOrderDropdown = false;

  // For Pagination
  pageSize = 8;
  currentPage = 1;

  get autoGenerateOrderLabel() {
    const { auto_generate_orders } = this.getSubscription;
    if (auto_generate_orders) return { color: "green", label: "Activado" };
    return { color: "gray", label: "Desactivado" };
  }

  get getSelectedTabOrder() {
    if (this.getDashboardSelectedTabIndex === 0) return this.getCurrentOrder;
    if (this.getDashboardSelectedTabIndex === 1) return this.getSubscription;
  }

  get isLastOrder() {
    const { name } = this.$route;
    if (name === "subscriptionLastOrderDetail" || name === "ordersHistoryDetail") return true;
    return false;
  }

  get isLastOrderInTerminalStatus() {
    if (this.getCurrentOrder) {
      return isOrderInTerminalStatus(this.getCurrentOrder);
    }
    return true;
  }

  mounted() {
    const { name } = this.$route;
    if (name === "subscriptionLastOrderDetail" && !this.getCurrentOrder) {
      this.$router.replace({ name: "subscriptionOrdersHome" });
    }
  }

  payOrder() {
    if (isMissingDocumentInformation(this.getUser)) {
      this.isShowingAddDocumentModal = true;
    } else {
      window.open(`https://checkout.wompi.co/l/${this.getCurrentOrder.payment_link}`, "_blank");
    }
  }

  async changeSubscriptionStatus(newStatus) {
    const payload = {
      commerceId: this.getCity.id,
      subscriptionId: this.getSubscription.id,
      subscription: {
        subscription: {
          status: newStatus,
        },
      },
    };
    try {
      this.SPINNER(true);
      await this.action_updateSubscription(payload);
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error al actualizar la suscripción. ${
          error.response && error.response.data && error.response.data.message
        }}`,
      });
    }
    this.SPINNER(false);
  }

  onConfirmOrder() {
    if (isMissingDocumentInformation(this.getUser)) {
      this.isShowingAddDocumentModal = true;
    } else {
      this.isShowingConfirmOrderModal = true;
    }
  }
}
